/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ActivityRespondedActivityReplyInner } from './ActivityRespondedActivityReplyInner';
import {
    ActivityRespondedActivityReplyInnerFromJSON,
    ActivityRespondedActivityReplyInnerFromJSONTyped,
    ActivityRespondedActivityReplyInnerToJSON,
} from './ActivityRespondedActivityReplyInner';

/**
 * 
 * @export
 * @interface Activity
 */
export interface Activity {
    /**
     * 
     * @type {string}
     * @memberof Activity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Activity
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Activity
     */
    description: string;
    /**
     * 
     * @type {Array<ActivityRespondedActivityReplyInner>}
     * @memberof Activity
     */
    respondedActivityReply: Array<ActivityRespondedActivityReplyInner>;
}

/**
 * Check if a given object implements the Activity interface.
 */
export function instanceOfActivity(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "respondedActivityReply" in value;

    return isInstance;
}

export function ActivityFromJSON(json: any): Activity {
    return ActivityFromJSONTyped(json, false);
}

export function ActivityFromJSONTyped(json: any, ignoreDiscriminator: boolean): Activity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'description': json['description'],
        'respondedActivityReply': ((json['respondedActivityReply'] as Array<any>).map(ActivityRespondedActivityReplyInnerFromJSON)),
    };
}

export function ActivityToJSON(value?: Activity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'description': value.description,
        'respondedActivityReply': ((value.respondedActivityReply as Array<any>).map(ActivityRespondedActivityReplyInnerToJSON)),
    };
}

